export default __webpack_public_path__ + "fonts/704899d6052d43789a5a91d5cf471ebd.woff2";